import * as React from "react";

import { useParams, Link } from "react-router-dom";
import OptionsList from "./OptionsList";
import FilterContext from "./context/Filter";
import FilterProvider from "./providers/Filter";
import NoOptions from "./NoOptions";

const EditFilterBody = () => {
  const ctx = React.useContext(FilterContext);

  if (ctx.isLoading) return <div>Loading filter...</div>;
  if (ctx.error) return <div>Error!</div>;

  return (
    <>
      <div className="vm-mb-4">
        <div className="vm-text-xl">Edit Filter: {ctx.state.title}</div>
        <Link to="/filters" className="vm-text-blue-500">
          Back to all filters
        </Link>
      </div>

      <div
        className="vm-grid vm-grid-cols-2"
        style={{ gridTemplateColumns: `320px 800px` }}
      >
        <div />

        <div>
          <div>
            {ctx.state.options.length === 0 ? <NoOptions /> : <OptionsList />}
          </div>
        </div>
      </div>
    </>
  );
};

const EditFilter = () => {
  const params = useParams();
  return (
    <FilterProvider id={params.filterId}>
      <EditFilterBody />
    </FilterProvider>
  );
};

export default EditFilter;
